<template>
  <v-tooltip top>
    <template v-slot:activator="{ on, attrs }">
      <v-btn fab x-small outlined v-bind="attrs" color="grey" v-on="on"><v-icon>{{mdiCalendar}}</v-icon></v-btn>
    </template>
    <span>This number will be transfered on {{confirmedTransferDate | formatDate}}</span>
  </v-tooltip>
</template>

<script>
  import { mdiCalendar } from '@mdi/js';

  export default {
    props: ['confirmedTransferDate'],
    data() {
      return {
        mdiCalendar,
      }
    },
  }
</script>

<style>

</style>
